import React from 'react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import { classNames } from '../../util/helpers'
import styles from './IconButton.module.scss'

const IconButton = ({
  icon,
  onClick,
  blue,
  spin,
  border,
  stretched,
  ...props
}) => (
  <button
    type="button"
    className={classNames(
      styles.iconButton,
      blue && styles.blue,
      spin && styles.spin,
      border && styles.border,
      stretched && styles.stretched,
    )}
    onClick={() => onClick()}
    {...props}
  >
    <span className={`${styles.icon} ${midas[icon]}`} />
  </button>
)

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default IconButton
